// @flow
import type {Element} from 'react'
import React from 'react'

type Props = {
  onClearAll: Function,
  onSelectAll: Function,
}

function SelectItemControls({onClearAll, onSelectAll}: Props): Element<"div"> {
  return (
    <div className="test-refinery-select-items__controls refinery-select-items__controls">
      <button
        className="btn btn-sm btn-outline-primary d-block w-100 mb-2 test-btn-select-all"
        onClick={onSelectAll}
        type="button"
      >
        {I18n.t('proposals.rewrite.select_all')}
      </button>
      <button
        className="btn btn-sm btn-outline-primary d-block w-100 test-btn-clear-all"
        onClick={onClearAll}
        type="button"
      >
        {I18n.t('proposals.rewrite.clear_all')}
      </button>
    </div>
  )
}

export default SelectItemControls
